import { render, staticRenderFns } from "./AttendancesReport.vue?vue&type=template&id=1b2365f5&scoped=true&"
import script from "./AttendancesReport.vue?vue&type=script&lang=js&"
export * from "./AttendancesReport.vue?vue&type=script&lang=js&"
import style0 from "./AttendancesReport.vue?vue&type=style&index=0&id=1b2365f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2365f5",
  null
  
)

export default component.exports